import ArcadeConfig, { type ArcadeConfigType } from "./ArcadeConfig";

export const GAME_TYPES = {
	ARCADE: 0,
	DEFAULT: 1,
};

export type ArcadeConfigProps = {
	gameConfig: ArcadeConfigType;
	setGameConfig: (config: ArcadeConfigType) => void;
	loading?: boolean;
};

export const getGameConfigComponent = (gameType: number, props: ArcadeConfigProps) => {
	switch (gameType) {
		case GAME_TYPES.ARCADE:
			return <ArcadeConfig {...props} />;
		default:
			return <ArcadeConfig {...props} />; // Default to Arcade config
	}
};
